// @ts-nocheck

export interface IIUserUsageInput {
    billAmount: number;
    billFrequency: BillFrequencyEnum;
    whenEnergyUsedMost: WhenEnergyUsedMostEnum;
    sessionId: string;
}
export enum BillFrequencyEnum {
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly'
}
export enum WhenEnergyUsedMostEnum {
    MAINLY_DURING_THE_DAY = 'mainly during the day',
    EVENING = 'evening',
    BOTH_DURING_THE_DAY_AND_IN_THE_EVENING = 'both during the day and in the evening',
    IN_THE_EVENING_AND_ON_THE_WEEKENDS = 'in the evening and on the weekends'
}

